import React, { useState } from "react";
import { Button } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { History } from "../History";
import { HistoryAuditLogs } from "../HistoryAuditLogs";

type HistoryViewT = "history" | "auditLogs";

const HistoryTab = () => {
  const { t } = useTranslation("translation", { keyPrefix: "History Page" });
  const [currentView, setCurrentView] = useState<HistoryViewT>("history");

  const renderNavigation = () => (
    <div style={{ display: "flex", gap: "8px", marginBottom: "24px", marginTop: "8px" }}>
      <Button
        data-test-id="history-credits"
        variant={currentView === "history" ? "primary" : "secondary"}
        onClick={() => setCurrentView("history")}
      >
        {t("Credits")}
      </Button>
      <Button
        data-test-id="history-audit-logs"
        variant={currentView === "auditLogs" ? "primary" : "secondary"}
        onClick={() => setCurrentView("auditLogs")}
      >
        {t("User changes")}
      </Button>
    </div>
  );

  const renderContent = () => {
    if (currentView === "history") {
      return <History />;
    } else if (currentView === "auditLogs") {
      return <HistoryAuditLogs />;
    }
  };

  return (
    <div>
      {renderNavigation()}
      {renderContent()}
    </div>
  );
};

export default HistoryTab;
